module.exports = __webpack_public_path__ + "img/search.03bba07b.png";